<script lang="ts">
  import type { DisplayView } from '@banger/shared';
  import { send } from '../lib/connection';
  import PlayerList from '../shared/PlayerList.svelte';

  let { view }: { view: DisplayView } = $props();

  const canSkip = $derived(view.phase === 'spin' || view.phase === 'answer');
  // Pause holds the phase clock, so it needs one running.
  const canPause = $derived(view.paused || view.deadline !== null);

  let confirming = $state(false);
  let confirmTimer: ReturnType<typeof setTimeout> | undefined;
  function endMatch() {
    if (!confirming) {
      confirming = true;
      confirmTimer = setTimeout(() => (confirming = false), 3000);
      return;
    }
    clearTimeout(confirmTimer);
    confirming = false;
    send({ type: 'end_match' });
  }
  $effect(() => () => clearTimeout(confirmTimer));

  // Mid-match roster, e.g. to remove someone who left for good.
  let roster = $state(false);
</script>

{#if roster}
  <div class="roster" role="dialog" aria-label="Players">
    {#if view.players.length === 0}<p>No players</p>{/if}
    <PlayerList players={view.players} onkick={(id) => send({ type: 'kick', playerId: id })} />
  </div>
{/if}
<nav aria-label="Host controls">
  <button class:on={roster} aria-expanded={roster} onclick={() => (roster = !roster)}>👥 Players</button>
  {#if view.paused}
    <button onclick={() => send({ type: 'resume' })}>▶ Resume</button>
  {:else}
    <button disabled={!canPause} onclick={() => send({ type: 'pause' })}>⏸ Pause</button>
  {/if}
  <button disabled={!canSkip} onclick={() => send({ type: 'skip_song' })}>⏭ Skip song</button>
  <button class:warn={confirming} onclick={endMatch}>{confirming ? 'Really end?' : '⏹ End match'}</button>
</nav>

<style>
  nav {
    position: fixed; right: 16px; bottom: 16px; z-index: 60; display: flex; gap: 8px; padding: 6px;
    border-radius: 999px; background: rgba(10, 6, 24, 0.7); border: 1px solid rgba(125, 249, 255, 0.25);
    opacity: 0.55; transition: opacity 0.2s;
  }
  nav:hover, nav:focus-within { opacity: 1; }
  button {
    font: inherit; font-weight: 700; font-size: 1rem; color: #fff; cursor: pointer; white-space: nowrap;
    padding: 0 16px; border-radius: 999px; border: 1px solid rgba(255, 255, 255, 0.2); background: rgba(255, 255, 255, 0.08);
  }
  button:hover:not(:disabled) { background: rgba(255, 61, 242, 0.3); border-color: var(--pink); }
  button:disabled { opacity: 0.35; cursor: not-allowed; }
  .warn, .on { background: var(--pink); border-color: var(--pink); }
  .roster {
    position: fixed; right: 16px; bottom: 76px; z-index: 60; max-width: min(720px, calc(100vw - 32px)); padding: 12px;
    border-radius: 20px; background: rgba(10, 6, 24, 0.92); border: 1px solid rgba(125, 249, 255, 0.35);
  }
  .roster p { margin: 0; opacity: 0.7; }
</style>
